// =======================
// == Animations/SearchForm.js ==
// =======================
/*
  All of the animations for SearchForm.js
*/

import Animator from './animator';
const { call, animations } = new Animator();
// Remove the form input and submission button
// with a subtle fadeout
const animate = () =>
  call(['#domainInput', '#submitButton'], animations.downAndOut);

export default animate;
